import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '@clerk/clerk-react';
import api from '../api';

// Stato del piano di abbonamento del fornitore loggato (da /pagamenti/stato).
// Ritorna { piano, isPro, stripeAttivo, piano_scadenza, cadenze, haAbbonamento, loading, ricarica }.
export default function usePiano() {
  const { isSignedIn, isLoaded } = useAuth();
  const [stato, setStato] = useState({
    piano: 'free',
    isPro: false,
    stripeAttivo: false,
    piano_scadenza: null,
    cadenze: [],
    haAbbonamento: false,
  });
  const [loading, setLoading] = useState(true);

  const carica = useCallback(async () => {
    if (!isLoaded) return;
    if (!isSignedIn) {
      setLoading(false);
      return;
    }
    try {
      const res = await api.get('/pagamenti/stato');
      setStato(res.data);
    } catch (_e) {
      // Lascia i default (free): il gating resta conservativo.
    } finally {
      setLoading(false);
    }
  }, [isSignedIn, isLoaded]);

  useEffect(() => {
    carica();
  }, [carica]);

  return { ...stato, loading, ricarica: carica };
}

// Avvia il checkout Stripe per la cadenza scelta ('annuale' di default) e reindirizza
// l'utente. Lancia in caso di errore (es. Stripe non configurato): il chiamante mostra il messaggio.
export async function avviaUpgrade(cadenza = 'annuale') {
  // Difesa: se per errore arriva un evento/oggetto (es. onClick passato senza arrow),
  // ricade su 'annuale' invece di mandare roba non serializzabile nel body.
  const c = cadenza === 'mensile' || cadenza === 'annuale' ? cadenza : 'annuale';
  const res = await api.post('/pagamenti/checkout', { cadenza: c });
  if (res.data?.url) {
    window.location.href = res.data.url;
    return;
  }
  throw new Error('Pagamenti non disponibili al momento.');
}

// Apre lo Stripe Customer Portal per gestire/disdire l'abbonamento e reindirizza.
export async function apriPortaleAbbonamento() {
  const res = await api.post('/pagamenti/portale');
  if (res.data?.url) {
    window.location.href = res.data.url;
    return;
  }
  throw new Error('Gestione abbonamento non disponibile al momento.');
}
